export default __webpack_public_path__ + "static/media/money2.7e94636e.jpg";